import page_logo from "../../images/logo.png";

export const PostHead = ({ publisher, publicationDate, readingTime }) => {
    return (
        <div className="container d-flex gap-3 post-head align-items-end mb-3 p-0" >
            <img src={page_logo} alt="puertoricocartransfer" width={30} />
            <p className="m-0 p-0">{publisher} <span>-</span> {publicationDate} <span>-</span> {readingTime} Min. de lectura</p>
        </div>
    )
}